import projectsService from '../../services/projectsService';
import ReduxConstants from '../../constants/ReduxConstants';
import dataModel from '../../models/DataModel.js';
import AOCollection from './AOCollection.js';

export default class AssignedProjectsCollection extends AOCollection {
  constructor(perPage, filter, userId) {
    super({
      name: ReduxConstants.ASSIGNED_PROJECTS,
      collectionType: ReduxConstants.PROJECT,
      perPage, 
      sortField: 'is_favorite',
      filter, 
      userId,
    });
    this.processItemActionCable = this.processItemActionCable.bind(this);
  }

  static build(perPage, filter) {
    let collection = new AssignedProjectsCollection(perPage, filter);
    let collectionData = dataModel.collectionsDAO.findCollection(collection.getKey());
    collection.page = 0;
    if (!collectionData) {
      collectionData = collection.getDefaultData();
      collectionData = dataModel.collectionsDAO.setCollection(collection.getKey(), collectionData, collection.getCollectionType());
    }
    return collection;
  }

  async fetchNext(pageOverride, options) {
    let perPage;
    if (dataModel.isOffline) {
      return this.handleOfflineFetch(options);
    }
    else {
      return new Promise(async (resolve) => {
        if (pageOverride) {
          this.page = pageOverride;
        }
        else {        
          this.page++;        
        }
        if(options && options.perPage){
          perPage = options.perPage;
        }else{
          perPage = this.perPage;
        }
        let serviceCall = projectsService.searchMyProjects.bind(this, this._filter.searchString, this.sortField, true, this._filter, this.page, perPage, options);
      
        let newCollection = await this._fetchData(serviceCall, options, true);

        newCollection.totalProjects = newCollection.meta ? newCollection.meta.total_projects : 0;
        return resolve(newCollection);
      });
    }
  }

  async fetchCurrent(shouldPaginate = true, options={}) {
    options.clear = true;
    if (dataModel.isOffline) {
      return this.handleOfflineFetch(options);
    }
    else {
      return new Promise(async (resolve) => {
        let collection = this.findCollection();
    
        let page = null;
        let perPage = null;
        
        // Get everything we already got
        
        if(typeof options.perPage!='undefined' || options.perPage!=null){
          page = 1;
          perPage=options.perPage;
        }else{
          if (shouldPaginate) {
            page = 1;
            if (this.perPage) {
       
              perPage =localStorage.getItem('favorite_projects') && localStorage.getItem('favorite_projects') >15? localStorage.getItem('favorite_projects'):Math.max(this.perPage, collection.ids.length);
            }
          }
        }
  
        const serviceCall = projectsService.searchMyProjects.bind(this, this._filter.searchString, this.sortField, true, this._filter, page, perPage, false, options);
                
        let newCollection = await this._fetchData(serviceCall, options, true);
    
        if (newCollection) {
          newCollection.totalProjects = newCollection.meta ? newCollection.meta.total_projects : 0;
          resolve(newCollection);
        }
        else {
          resolve({ ids: [], projects: [] });
        }
      });
    }
  }

  handleOfflineFetch(options) {
    return new Promise((resolve) => {
      let collection = this.getDenormalizedCollection(options);
      if (collection) {
        collection.projects = dataModel.projectsDAO.getOfflineProjects(options);
        collection.ids = collection.projects.map(project => { return project.id; });
      }
      return resolve(collection);
    });
  }

  async processItemActionCable(updatedProject, acData, recordDescriptor) {
    return new Promise((resolve) => {
      const projectsCollection = this.getDenormalizedCollection({ recordDescriptor });
      if (acData.type == 'updateProject' || acData.type == 'updateProjectMemberAssignments') {
        if (updatedProject) {
          let found = false;
          
          projectsCollection.projects = projectsCollection.projects.map(proj => {
            if (proj.id == updatedProject.id) {
              found = true;
              return updatedProject;
            }
            else {
              return proj;
            }
          });
          if (!found) {
            let addProject = false;
            if (acData.type == 'updateProjectMemberAssignments') {
              addProject = true;
            }
            else {
              if (updatedProject.project_users &&
                updatedProject.project_users.filter(user => { return user.user_id == dataModel.usersDAO.currentUser.id;}).length > 0) {
                addProject = true;
              }
              else if (updatedProject.users &&
                updatedProject.users.filter(user => { return user.id == dataModel.usersDAO.currentUser.id;}).length > 0) {
                addProject = true;
              }
            }
            if (addProject) {
              projectsCollection.projects.push(updatedProject);
              projectsCollection.meta.total_projects++;
              projectsCollection.totalRecords = projectsCollection.totalProjects = projectsCollection.meta.total_projects;
            }
          }
          projectsCollection.ids = this.normalizeCollection(projectsCollection.projects, { store: true });
          dataModel.collectionsDAO.setCollection(this.getKey(), projectsCollection, this.getCollectionType());
          return resolve(this.getDenormalizedCollection({ recordDescriptor }));
        }
      }
      else if (acData.type == 'deleteProject' || acData.type == 'removeProjectMemberAssignments') {
        let found = false;
        projectsCollection.projects = projectsCollection.projects.filter(proj => {
          if (proj.id != acData.project_id){
            return true;
          }
          else {
            found = true;
            return false;
          }
        });
        if (found) {
          projectsCollection.meta.total_projects--;
        }
        projectsCollection.totalRecords = projectsCollection.totalProjects = projectsCollection.meta.total_projects;
        projectsCollection.ids = this.normalizeCollection(projectsCollection.projects, { store: true });
        dataModel.collectionsDAO.setCollection(this.getKey(), projectsCollection, this.getCollectionType());
        return resolve(this.getDenormalizedCollection({ recordDescriptor }));
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/dao/collections/AssignedProjectsCollection.js